/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 16.09.2020
 * Description : Configurations des requêtes API pour les fichiers des stages
 * Fichier : stageFileService.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/stageFiles'

export default {
  getStageFile(id) {
    return axios.get(API_URL + `${CONTROLLER}/${id}`, {
      responseType: 'blob' // important
    })
  },
  postStageFile(formData) {
    return axios.post(API_URL + CONTROLLER, formData)
  },
  deleteStageFile(id) {
    return axios.delete(API_URL + `${CONTROLLER}/${id}`)
  }
}
